import { __spreadArray } from 'tslib';
import React__default from 'react';
import { MediaField, dayjs } from '@keepeek/commons';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import capitalize from 'lodash/capitalize';
import isArray from 'lodash/isArray';
import trim from 'lodash/trim';
import { useTranslation } from 'react-i18next';
import FormatTechnicalFolders from './FormatTechnicalFolders.js';
import { classes, StyledFormatTechnicalFields } from './styles.js';

var FormatTechnicalField = function (_a) {
    var _b;
    var field = _a.field, fields = _a.fields;
    var t = useTranslation("refront-components").t;
    switch (field.id) {
        case MediaField.RESOLUTION: {
            if (field.value === "-1") {
                return null;
            }
            var value = t("components.mediafield_resolution_dpi", { resolution: field.value });
            return (React__default.createElement(Typography, { variant: "caption", className: classes.field, sx: { whiteSpace: "nowrap" }, title: field.name }, value));
        }
        case MediaField.DURATION_IN_SECONDS: {
            if (field.value === "" || field.value === "0") {
                return null;
            }
            var duration = Number(isArray(field.value) ? field.value[0] : field.value);
            return (React__default.createElement(Typography, { variant: "caption", className: classes.field, title: field.name }, dayjs.duration(duration, "seconds").format("H:mm:ss")));
        }
        case MediaField.WIDTH: {
            var widthValue = field.value;
            var heightValue = (_b = fields === null || fields === void 0 ? void 0 : fields.find(function (t) { return t.id === MediaField.HEIGHT; })) === null || _b === void 0 ? void 0 : _b.value;
            if (widthValue && heightValue && widthValue !== "-1" && heightValue !== "-1") {
                return (React__default.createElement(Typography, { variant: "caption", title: t("mediafield_dimensions"), className: classes.field },
                    widthValue,
                    React__default.createElement("small", null, "x"),
                    heightValue));
            }
            return null;
        }
        case MediaField.HEIGHT:
            // do nothing cause it is handled in WIDTH
            return null;
        case MediaField.MEDIA_TYPE: {
            return (React__default.createElement(Typography, { variant: "caption", className: clsx(classes.field, classes.mediaType), title: field.name }, field.value));
        }
        case MediaField.FILE_SIZE_STRING: {
            var multi = field.value.toString().split(" ").length > 1;
            var value = multi ? field.value.toString().split(" ")[0] : field.value.toString();
            var size = multi ? field.value.toString().split(" ")[1] : "";
            return (React__default.createElement(Typography, { variant: "caption", className: classes.field, title: field.name },
                value,
                React__default.createElement("small", null, size)));
        }
        case MediaField.EXTENSION: {
            return (React__default.createElement(Typography, { variant: "caption", className: clsx(classes.field, classes.mediaType), title: capitalize(field.name) }, field.value));
        }
        case MediaField.IMPORT_DATE:
        case MediaField.UPDATE_DATE:
        case MediaField.TRASH_DATE:
        case MediaField.CREATION_DATE: {
            var val = void 0;
            if (field.value && !Array.isArray(field.value)) {
                val = dayjs(field.value).format("LL");
            }
            if (!val) {
                return null;
            }
            return (React__default.createElement(Typography, { variant: "caption", className: classes.field, title: field.name }, val));
        }
        default: {
            if (field.value === null || field.value === undefined) {
                console.debug("field ".concat(field.name, " has no value"));
                return null;
            }
            if (typeof field.value === "string") {
                if (trim(field.value).length > 0) {
                    return (React__default.createElement(Typography, { variant: "caption", className: classes.field, title: field.name }, field.value));
                }
                else {
                    return null;
                }
            }
            return (React__default.createElement(Typography, { variant: "caption", className: classes.field, title: field.name }, Array.isArray(field.value) ? __spreadArray([], field.value, true).join(" _ ") : field.value));
        }
    }
};
var FormatTechnicalFields = function (_a) {
    var element = _a.element, technicalFieldsToDisplay = _a.technicalFieldsToDisplay, folderDisplayMode = _a.folderDisplayMode, onFolderClick = _a.onFolderClick, className = _a.className, KIcon = _a.KIcon;
    var fields = element.fields;
    return (React__default.createElement(StyledFormatTechnicalFields, { className: clsx("FormatTechnicalFields", classes.root, className) }, technicalFieldsToDisplay.map(function (fieldToDisplay) {
        if (fieldToDisplay === MediaField.FOLDER_ID) {
            return (React__default.createElement(FormatTechnicalFolders, { key: fieldToDisplay, folders: element.folders, displayMode: folderDisplayMode, onFolderClick: onFolderClick, KIcon: KIcon }));
        }
        var field = fields === null || fields === void 0 ? void 0 : fields.find(function (f) { return f.id === fieldToDisplay; });
        if (!field) {
            return null;
        }
        return React__default.createElement(FormatTechnicalField, { key: field.id, field: field, fields: fields });
    })));
};

export { FormatTechnicalField, FormatTechnicalFields as default };
//# sourceMappingURL=index.js.map
